<template>
  <div>
    <v-container v-if="dataloaded" grid-list-md class="pa-0 pt-2" fluid>
      <v-layout row wrap>
        <v-flex md3 xs12 v-if="companies.length > 1 && !demoMode">
          <v-select
            :items="filteredCompanies"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"
            item-text="name"
            item-value="id"
            hide-details
            v-on:input="loadBranches()"
            v-model="activeComp"
            no-data-text="Geen bedrijven gevonden."
            label="Selecteer bedrijf"
            outlined
          >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content class="pt-0">
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    prepend-inner-icon="search"
                    clearable
                    v-model="searchCompanies"
                    hide-details
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div
                v-if="searchCompanies && searchCompanies.length > 0"
                style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px"
              >
                {{ filteredCompanies.length }} van
                {{ companies.length }} bedrijven
              </div>
              <v-divider
                v-if="searchCompanies && searchCompanies.length > 0"
              ></v-divider>
            </template>
          </v-select>
        </v-flex>
        <v-flex :class="branchesWidth" xs12>
          <v-select
            height="44px"
            :item-color="companyPrimaryColor"
            :color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"
            :items="branches"
            item-text="branchName"
            item-value="id"
            v-model="selectedBranches"
            multiple
            label="Vestigingen"
            attach
            outlined
            hide-details
            chips
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span>{{ item.branchName }}</span>
              </v-chip>
              <v-chip v-if="index === 1">
                <span>{{ item.branchName }}</span>
              </v-chip>
              <v-chip v-if="index === 2">
                <span>{{ item.branchName }}</span>
              </v-chip>
              <span style="color: #666; font-size: 14px;" v-if="index === 3">
                + {{ selectedBranches.length - 3 }} anderen
              </span>
            </template>
          </v-select>
        </v-flex>
        <v-flex v-if="branches.length > 1" md3 xs12>
          <v-btn
            block
            :depressed="branchesChanged"
            large
            height="55px"
            :disabled="branchesChanged"
            :color="companyPrimaryColor"
            @click="loadSelectedBranchesData()"
          >
            <span style="color: #fff;">Afspraken laden</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <div v-if="!dataloaded && userDataLoaded" class="blackbox-loader"></div>

    <div class="no-salon-data" v-if="dataloaded && noData">
      <p>
        Selecteer salons en klik op <strong>Afspraken laden</strong> om data te
        laden.
      </p>
    </div>

    <div class="no-salon-data" v-if="dataloaded && !noData && loadingError">
      <v-layout justify-space-around>
        <v-icon large color="warning">warning</v-icon>
      </v-layout>
      <p style="padding: 10px">{{ loadingError }}</p>
    </div>

    <v-card outlined class="mt-4" v-if="dataloaded && !noData && !loadingError">
      <v-card-title>
        <v-text-field
          style="max-width: 300px;"
          v-model="search"
          :color="companyPrimaryColor"
          placeholder="Zoeken"
          outlined
          hide-details
          background-color="background"
          prepend-inner-icon="search"
          autocomplete="disabled"
          clearable
        >
        </v-text-field>
        <v-spacer></v-spacer>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="newClientsAppointmentsFiltered"
        :itemsPerPage.sync="clientPages"
        v-model="selected"
        hide-default-footer
      >
        <template v-slot:item="{ item, index }">
          <tr>
            <td>{{ index + 1 }}</td>
            <td>{{ item.appointmentDate | moment("D MMM YYYY - H:mm") }}u</td>
            <td>{{ item.name }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.telephone }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
import db from "../firebase/init";
import moment from "vue-moment";
import axios from "axios";
import Moment from "moment";
import lodash from "lodash";

export default {
  name: "onlineClientsSalonhub",
  data: () => ({
    branches: [],
    selectedBranches: [],
    selectedBranchesOriginal: [],
    selectedBranchesData: [],
    companies: [],
    newClientsAppointments: [],
    dataloaded: false,
    noData: false,
    userDataLoaded: true,
    activeComp: null,
    activeCompData: null,
    activeCompDataOriginal: null,
    searchCompanies: "",
    search: "",
    selected: [],
    clientPages: -1,
    loadingError: null,
    newClientsAppointments: [],
    headers: [
      {
        text: "",
        align: "left",
        width: "60px",
      },
      {
        text: "Afspraakdatum",
        align: "left",
        value: "appointmentDate",
      },
      {
        text: "Naam",
        align: "left",
        value: "name",
      },
      {
        text: "E-mail",
        align: "left",
        value: "email",
      },
      {
        text: "Telefoonnummer",
        align: "left",
        value: "telephone",
      },
    ],

    pagination: {
      rowsPerPage: "-1",
      sortBy: "appointmentDate",
      descending: true,
    },
  }),

  created() {
    this.loadUserComp();
    // this.loadCompanies();
    // this.getCompanySettings();
  },

  methods: {
    loadUserComp() {
      this.userDataLoaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let vm = this;
      let getUserCompData = getUserComp();

      async function getUserComp() {
        for (const company of userCompanies) {
          await db
            .collection("companies")
            .doc(company)
            .get()
            .then((doc) => {
              if (doc.data().apiItems.salonhub == true) {
                let company = {};
                company.name = doc.data().name;
                company.id = doc.id;
                if (doc.data().barometersSettings) {
                  company.barometersSettings = doc.data().barometersSettings;
                } else {
                  company.barometersSettings = {};
                }
                company.salonhubApiSettings = doc.data().salonhubApiSettings;
                company.benchmarkEmployees = doc.data().benchmarkEmployees;
                vm.companies.push(company);
              }
            });
        }
        vm.activeComp = vm.companies[0].id;
        vm.loadBranches();
      }
    },

    loadBranches() {
      console.log("load Branches");

      this.dataloaded = false;
      // Load active comp data
      this.companies.forEach((data) => {
        if (data.id == this.activeComp) {
          this.activeCompData = data;
          this.activeCompDataOriginal = _.cloneDeep(data);
        }
      });

      // Load branches
      this.branches = [];
      this.selectedBranches = [];

      if (this.userRole == "employee" || this.userRole == "manager") {
        if (this.userBranches.length > 0) {
          this.selectedBranches = this.userBranches;
          let branchCounter = 0;
          new Promise((resolve, reject) => {
            this.selectedBranches.forEach((branch) => {
              db.collection("branches")
                .doc(branch)
                .get()
                .then((doc) => {
                  let branchCollection = doc.data();
                  branchCollection.id = doc.id;
                  this.branches.push(branchCollection);
                })
                .then(() => {
                  branchCounter++;
                  if (branchCounter == this.selectedBranches.length) {
                    resolve();
                  }
                });
            });
          }).then(() => {
            if (this.selectedBranches.length < 2) {
              this.loadSelectedBranchesData();
            } else {
              console.log(
                "Te veel branches. Gebruik buttom om data zelf te laden.",
              );
              this.userDataLoaded = true;
              this.dataloaded = true;
              this.noData = true;
            }
          });
        } else {
          this.userDataLoaded = true;
          this.dataloaded = true;
          this.noData = true;
        }
      } else {
        db.collection("branches")
          .where("compId", "==", this.activeComp)
          .get()
          .then((snap) => {
            snap.forEach((doc) => {
              let branchCollection = doc.data();
              branchCollection.id = doc.id;
              this.branches.push(branchCollection);
              this.selectedBranches.push(doc.id);
            });
          })
          .then(() => {
            if (this.selectedBranches.length < 2) {
              this.loadSelectedBranchesData();
            } else {
              console.log(
                "Te veel branches. Gebruik buttom om data zelf te laden.",
              );
              this.userDataLoaded = true;
              this.dataloaded = true;
              this.noData = true;
            }
          });
      }
    },

    loadSelectedBranchesData() {
      this.dataloaded = false;
      this.selectedBranchesData = [];
      this.selectedBranchesOriginal = _.cloneDeep(this.selectedBranches);

      if (this.selectedBranches.length > 0) {
        new Promise((resolve, reject) => {
          let branchCounter = 0;
          this.selectedBranches.forEach((item) => {
            db.collection("branches")
              .doc(item)
              .get()
              .then((doc) => {
                branchCounter++;
                let branch = doc.data();
                branch.id = doc.id;
                this.selectedBranchesData.push(branch);
                if (branchCounter === this.selectedBranches.length) {
                  resolve();
                }
              });
          });
        }).then(() => {
          this.noData = false;
          this.userDataLoaded = true;
          this.getAppointments();
        });
      } else {
        this.userDataLoaded = true;
        this.dataloaded = true;
        this.noData = true;
      }
    },

    getAppointments() {
      // Haal alle gemaakte afspraken binnen
      this.loadingError = null;
      this.dataloaded = false;
      this.newClientsAppointments = [];
      let counterBranches = 0;

      new Promise((resolve, reject) => {
        this.selectedBranchesData.forEach((branch) => {
          axios
            .get(
              `https://engine.salonhub.nl/001/${
                this.activeCompData.salonhubApiSettings.customer
              }/${this.activeCompData.salonhubApiSettings.username}/${
                this.activeCompData.salonhubApiSettings.md5
              }/salon/${
                branch.branchNameSalonhub
              }/getReport?name=Reports.Online.History&parameters={"period":"month","year":${Moment().year()},"from":"${Moment()
                .subtract(2, "months")
                .startOf("month")
                .format("YYYY-MM-DD")}","to":"${Moment()
                .endOf("month")
                .format("YYYY-MM-DD")}"}`,

              // Officiele api:
              // /getReport?name=Reports.Online.History&parameters={"period":"month","year":2019,"month":8,"from":"2019-08-01","to":"2019-08-31","previous":{"year":2019,"month":7,"from":"2019-07-01","to":"2019-07-31"},"next":{"year":2019,"month":9,"from":"2019-09-01","to":"2019-09-30"}}`,

              // Verkorte versie
              // /getReport?name=Reports.Online.History&parameters={"period":"month","year":2019,"from":"2019-08-01","to":"2019-08-31"}

              { timeout: 5000 },
            )
            .then((response) => {
              //Data netjes in het Array geheugen
              for (
                let index = 0;
                index < response.data.data.transactions.length;
                index++
              ) {
                if (!response.data.data.transactions[index].customer) {
                  let client = response.data.data.transactions[index];
                  client.appointmentDate = Number(client.date);
                  let today = Moment().unix();

                  _.uniqBy([{ x: 1 }, { x: 2 }, { x: 1 }], "x");

                  if (client.appointmentDate <= today) {
                    this.newClientsAppointments.push(client);
                  }
                }
              }
              counterBranches++;
              if (this.selectedBranchesData.length == counterBranches) {
                resolve();
              }
            })
            .catch((error) => {
              console.error("Error loading appointments: ", error);
              this.dataloaded = true;
              this.loadingError =
                "Er is iets fout gegaan bij het binnenhalen van Salonhub. Probeer het opnieuw.";
            });
        });
      })
        .then(() => {
          this.newClientsAppointments = _.uniqBy(
            this.newClientsAppointments,
            "email",
          );
        })
        .then(() => {
          this.dataloaded = true;
          this.noData = false;
        });
    },
  },

  computed: {
    demoMode() {
      return this.$store.state.demoMode;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    userBranches() {
      return this.$store.state.userBranches;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    refreshDisabled() {
      if (this.dataloaded && this.noData == false) {
        return { status: false, color: "#333" };
      } else {
        return { status: true, color: "rgba(255,255,255, 0.3)" };
      }
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    filteredCompanies() {
      if (this.searchCompanies && this.searchCompanies.length > 0) {
        return this.companies.filter((company) => {
          return company.name
            .toLowerCase()
            .includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies;
      }
    },
    branchesChanged() {
      if (
        _.isEqual(this.selectedBranches, this.selectedBranchesOriginal) ==
          false ||
        this.loadingError
      ) {
        return false;
      } else {
        return true;
      }
    },
    newClientsAppointmentsFiltered() {
      return this.newClientsAppointments.filter((client) => {
        let clientinfo = client.name + " " + client.email;
        return clientinfo.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    branchesWidth() {
      if (this.companies.length > 1 && !this.demoMode) {
        return "md6";
      } else {
        return "md9";
      }
    },
  },
};
</script>
